module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.f7e77a49.eot";